/* globals lp,Class */
var ScriptElement = Class.create(
  lp.pom.Element,
  lp.ModuleComponent,
  {
    type:'lp-script',

    initialize: function($super, page, jso, context, options) {
      $super(page, jso, context, options);
      if (this.page.isPublishOrPreviewMode()) {
        this.page.addInsertion(
          this.model.get('content.html'),
          this.model.get('placement'),
          this.page.getLowestPriority()
        );
      }
    },

    createDefaultConstraints: function($super) {
      $super();
      this.defaultConstraints.displayable = false;
      this.defaultConstraints.copyable = false;
    }
  }
);

ScriptElement.elementDefaults = {
  name: 'Javascript',
  containerId: null,
  content: {
    type: null,
    valid: true,
    errors: []
  }
};

module.exports = ScriptElement;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-script/script_element.js
// module id = 585
// module chunks = 0 1